import type { Indicador } from '@erp/shared';

const moedaReais = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  maximumFractionDigits: 0,
});
const numero = new Intl.NumberFormat('pt-BR');

export function formatarIndicador(v: number | null, f: Indicador['formato']): string {
  if (v === null) return '—';
  switch (f) {
    case 'moeda':
      return moedaReais.format(v / 100);
    case 'dias':
      return `${numero.format(v)} dias`;
    case 'percentual':
      return `${numero.format(v)}%`;
    default:
      return numero.format(v);
  }
}

export const NOME_PAPEL = {
  dono: 'Dono',
  gerente: 'Gerente',
  vendedor: 'Vendedor',
  financeiro: 'Financeiro',
} as const;

const moedaCentavos = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  maximumFractionDigits: 0,
});
export const moeda = (centavos: number | null | undefined): string =>
  centavos === null || centavos === undefined ? '—' : moedaCentavos.format(centavos / 100);
const moedaComCentavos = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
/** Com centavos ("R$ 945,60"): pagamentos, parcelas, caixa e recibos. */
export const moedaExata = (centavos: number | null | undefined): string =>
  centavos === null || centavos === undefined ? '—' : moedaComCentavos.format(centavos / 100);
/** Valor em reais sem centavos ("R$ 397"), para preços de vitrine. */
export const reais = (centavos: number): string => moedaReais.format(centavos / 100);
export const km = (v: number) => `${new Intl.NumberFormat('pt-BR').format(v)} km`;
export const dataCurta = (iso: string) => new Date(iso).toLocaleDateString('pt-BR');
export const dataHora = (iso: string) =>
  new Date(iso).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });

/** "45.900" ou "45.900,50" digitado → centavos. */
export function textoParaCentavos(t: string): number | null {
  const s = t.replace(/[^\d,]/g, '');
  if (!s) return null;
  const [inteiro, dec = ''] = s.split(',');
  return Number(inteiro || '0') * 100 + Number((dec + '00').slice(0, 2));
}
export function centavosParaTexto(c: number | null | undefined): string {
  if (c === null || c === undefined) return '';
  const r = Math.floor(c / 100);
  const d = c % 100;
  return new Intl.NumberFormat('pt-BR').format(r) + (d ? `,${String(d).padStart(2, '0')}` : '');
}
/** 16.8 → "16,8%"; com sinal opcional (+3,2%). */
export const pct = (v: number | null | undefined, sinal = false): string =>
  v === null || v === undefined
    ? '—'
    : `${sinal && v > 0 ? '+' : ''}${v.toLocaleString('pt-BR', { maximumFractionDigits: 1 })}%`;
